const { prefersReducedMotion } = window.BAO.Utils

class MakersHero extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['text-content', 'text-content-inner']
  }

  connectedCallback () {
    super.connectedCallback()

    this.updateTextContent()
    this.updateImageScale()
    document.body.classList.add('lyt-MakersHero')
  }

  setupListeners () {
    super.setupListeners()

    if (!prefersReducedMotion()) {
      window.addEventListener('scroll', this.onScroll.bind(this), {
        passive: true,
      })
    }

    if (this.textContentEl && this.textContentInnerEl) {
      window.addEventListener('resize', this.onResize.bind(this), {
        passive: true,
      })
    }

    this.listeners.add(
      this,
      'READ_MORE::READ_MORE',
      this.handleReadMore.bind(this),
    )
    this.listeners.add(
      this,
      'READ_MORE::READ_LESS',
      this.handleReadLess.bind(this),
    )
  }

  handleReadMore () {
    this.toggleAttribute('expanded', true)
  }

  handleReadLess () {
    this.toggleAttribute('expanded', false)
  }

  onResize () {
    this.requestResizeTick()
  }

  requestResizeTick () {
    if (!this.resizeIsTicking) {
      requestAnimationFrame(this.updateTextContent.bind(this))
    }

    this.resizeIsTicking = true
  }

  updateTextContent () {
    this.toggleAttribute(
      'read-more-required',
      this.textContentEl.offsetHeight + 6 < this.textContentInnerEl.offsetHeight,
    )

    this.resizeIsTicking = false
  }

  onScroll () {
    this.requestScrollTick()
  }

  requestScrollTick () {
    if (!this.scrollIsTicking) {
      requestAnimationFrame(this.updateImageScale.bind(this))
    }

    this.scrollIsTicking = true
  }

  updateImageScale () {
    this.currentScroll = window.scrollY

    const isScrollingUp = this.currentScroll <= this.previousScroll
    const announcementBarEl = this?.externalEls?.announcement?.element
    const distanceToScrollWhenScrollingUp = announcementBarEl?.offsetHeight || 0
    const distanceToScroll = isScrollingUp ? distanceToScrollWhenScrollingUp : 0

    this.toggleAttribute('scrolled', this.currentScroll > distanceToScroll)

    this.previousScroll = this.currentScroll
    this.scrollIsTicking = false
  }

  /*
  get maxScale () {
    // Arbitrary value as this amount was confirmed desirable by the design team
    return 0.85
  }
  */

  get textContentEl () {
    return this.els?.['text-content']?.element
  }

  get textContentInnerEl () {
    return this.els?.['text-content-inner']?.element
  }
}

if (!customElements.get('makers-hero')) {
  customElements.define('makers-hero', MakersHero)
}
